const moment = require("moment-jalaali");

export const contentTypeFilters = [
  {
    label: "فیلم",
    key: "movie",
  },
  {
    label: "سریال",
    key: "series",
  },
  {
    label: "انیمیشن",
    key: "animation",
  },
  {
    label: "موزیک",
    key: "music",
  },
  {
    label: "برنامه",
    key: "program",
  },
  {
    label: "پخش زنده",
    key: "live",
  },
  {
    label: "آنلاین باخیش",
    key: "online-cinema",
  },
];

export const languageFilters = [
  { label: "فارسی", key: "farsi" },
  { label: "انگلیسی", key: "english" },
  { label: "ترکی", key: "turkish" },
  { label: "ترکی استانبولی", key: "turkish_istanbul" },
  { label: "فرانسه", key: "french" },
  { label: "عربی", key: "arabic" },
  { label: "اسپانیایی", key: "spanish" },
  { label: "آلمانی", key: "german" },
  { label: "ایتالیایی", key: "italian" },
  { label: "روسی", key: "russian" },
  { label: "چینی", key: "chinese" },
  { label: "ژاپنی", key: "japanese" },
  { label: "کره‌ای", key: "korean" },
  { label: "هندی", key: "hindi" },
  { label: "اردو", key: "urdu" },
  { label: "پرتغالی", key: "portuguese" },
  { label: "سوئدی", key: "swedish" },
  { label: "هلندی", key: "dutch" },
  { label: "یونانی", key: "greek" },
  { label: "متفرقه", key: "other" },
];

export const countryFilters = [
  { name: "Iran", key: "IR", label: "ایران" },
  { name: "Afghanistan", key: "AF", label: "افغانستان" },
  { name: "land Islands", key: "AX", label: "جزایر الند" },
  { name: "Albania", key: "AL", label: "آلبانی" },
  { name: "Algeria", key: "DZ", label: "الجزایر" },
  { name: "American Samoa", key: "AS", label: "ساموآی آمریکا" },
  { name: "AndorrA", key: "AD", label: "آندورا" },
  { name: "Angola", key: "AO", label: "آنگولا" },
  { name: "Anguilla", key: "AI", label: "آنگویلا" },
  { name: "Antigua and Barbuda", key: "AG", label: "آنتیگوآ و باربودا" },
  { name: "Argentina", key: "AR", label: "آرژانتین" },
  { name: "Armenia", key: "AM", label: "ارمنستان" },
  { name: "Aruba", key: "AW", label: "آروبا" },
  { name: "Australia", key: "AU", label: "استرالیا" },
  { name: "Austria", key: "AT", label: "اتریش" },
  { name: "Azerbaijan", key: "AZ", label: "آذربایجان" },
  { name: "Bahamas", key: "BS", label: "باهاما" },
  { name: "Bahrain", key: "BH", label: "بحرین" },
  { name: "Bangladesh", key: "BD", label: "بنگلادش" },
  { name: "Barbados", key: "BB", label: "باربادوس" },
  { name: "Belarus", key: "BY", label: "بلاروس" },
  { name: "Belgium", key: "BE", label: "بلژیک" },
  { name: "Belize", key: "BZ", label: "بلیز" },
  { name: "Benin", key: "BJ", label: "بنین" },
  { name: "Bermuda", key: "BM", label: "برمودا" },
  { name: "Bhutan", key: "BT", label: "بوتان" },
  { name: "Bolivia", key: "BO", label: "بولیوی" },
  { name: "Bosnia and Herzegovina", key: "BA", label: "بوسنی و هرزگوین" },
  { name: "Botswana", key: "BW", label: "بوتسوانا" },
  { name: "Bouvet Island", key: "BV", label: "جزیره بووه" },
  { name: "Brazil", key: "BR", label: "برزیل" },
  { name: "Brunei Darussalam", key: "BN", label: "برونئی" },
  { name: "Bulgaria", key: "BG", label: "بلغارستان" },
  { name: "Burkina Faso", key: "BF", label: "بورکینافاسو" },
  { name: "Burundi", key: "BI", label: "بوروندی" },
  { name: "Cambodia", key: "KH", label: "کامبوج" },
  { name: "Cameroon", key: "CM", label: "کامرون" },
  { name: "Canada", key: "CA", label: "کانادا" },
  { name: "Cape Verde", key: "CV", label: "کیپ ورد" },
  { name: "Cayman Islands", key: "KY", label: "جزایر کیمن" },
  {
    name: "Central African Republic",
    key: "CF",
    label: "جمهوری آفریقای مرکزی",
  },
  { name: "Chad", key: "TD", label: "چاد" },
  { name: "Chile", key: "CL", label: "شیلی" },
  { name: "China", key: "CN", label: "چین" },
  { name: "Christmas Island", key: "CX", label: "جزایر کریسمس" },
  { name: "Colombia", key: "CO", label: "کلمبیا" },
  { name: "Comoros", key: "KM", label: "اتحاد قمر" },
  { name: "Congo", key: "CG", label: "کنگو" },
  {
    name: "Congo, The Democratic Republic of the",
    key: "CD",
    label: "جمهوری دموکراتیک کنگو",
  },
  { name: "Cook Islands", key: "CK", label: "جزایر کوک" },
  { name: "Costa Rica", key: "CR", label: "کاستاریکا" },
  { name: "Croatia", key: "HR", label: "کرواسی" },
  { name: "Cuba", key: "CU", label: "کوبا" },
  { name: "Cyprus", key: "CY", label: "قبرس" },
  { name: "Czech Republic", key: "CZ", label: "جمهوری چک" },
  { name: "Denmark", key: "DK", label: "دانمارک" },
  { name: "Djibouti", key: "DJ", label: "جیبوتی" },
  { name: "Dominica", key: "DM", label: "دومینیکا" },
  { name: "Dominican Republic", key: "DO", label: "جمهوری دومینیکن" },
  { name: "Ecuador", key: "EC", label: "اکوادور" },
  { name: "Egypt", key: "EG", label: "مصر" },
  { name: "El Salvador", key: "SV", label: "السالوادور" },
  { name: "Equatorial Guinea", key: "GQ", label: "گینه استوایی" },
  { name: "Eritrea", key: "ER", label: "اریتره" },
  { name: "Estonia", key: "EE", label: "استونی" },
  { name: "Ethiopia", key: "ET", label: "اتیوپی" },
  { name: "Falkland Islands (Malvinas)", key: "FK", label: "جزایر فالکلند" },
  { name: "Faroe Islands", key: "FO", label: "جزایر فارو" },
  { name: "Fiji", key: "FJ", label: "فیجی" },
  { name: "Finland", key: "FI", label: "فنلاند" },
  { name: "France", key: "FR", label: "فرانسه" },
  { name: "French Guiana", key: "GF", label: "گویان فرانسه" },
  { name: "French Polynesia", key: "PF", label: "پولینزی فرانسوی" },
  { name: "Gabon", key: "GA", label: "گابن" },
  { name: "Gambia", key: "GM", label: "گامیا" },
  { name: "Georgia", key: "GE", label: "گرجستان" },
  { name: "Germany", key: "DE", label: "آلمان" },
  { name: "Ghana", key: "GH", label: "غنا" },
  { name: "Greece", key: "GR", label: "یونان" },
  { name: "Greenland", key: "GL", label: "گرینلند" },
  { name: "Grenada", key: "GD", label: "گرانادا" },
  { name: "Guam", key: "GU", label: "گوام" },
  { name: "Guatemala", key: "GT", label: "گواتمالا" },
  { name: "Guinea", key: "GN", label: "گینه" },
  { name: "Guinea-Bissau", key: "GW", label: "گینه بیسائو" },
  { name: "Guyana", key: "GY", label: "گویان" },
  { name: "Haiti", key: "HT", label: "هاییتی" },
  { name: "Honduras", key: "HN", label: "هندوراس" },
  { name: "Hong Kong", key: "HK", label: "هنگ‌کنگ" },
  { name: "Hungary", key: "HU", label: "مجارستان" },
  { name: "Iceland", key: "IS", label: "ایسلند" },
  { name: "India", key: "IN", label: "هند" },
  { name: "Indonesia", key: "ID", label: "اندونزی" },
  { name: "Iraq", key: "IQ", label: "عراق" },
  { name: "Ireland", key: "IE", label: "ایرلند" },
  { name: "Israel", key: "IL", label: "اسراییل" },
  { name: "Italy", key: "IT", label: "ایتالیا" },
  { name: "Jamaica", key: "JM", label: "جاماییکا" },
  { name: "Japan", key: "JP", label: "ژاپن" },
  { name: "Jordan", key: "JO", label: "اردن" },
  { name: "Kazakhstan", key: "KZ", label: "قزاقستان" },
  { name: "Kenya", key: "KE", label: "کنیا" },
  {
    name: "Korea, Democratic People'S Republic of",
    key: "KP",
    label: "کره شمالی",
  },
  { name: "Korea, Republic of", key: "KR", label: "کره جنوبی" },
  { name: "Kuwait", key: "KW", label: "کویت" },
  { name: "Kyrgyzstan", key: "KG", label: "قرقیزستان" },
  { name: "Lao People'S Democratic Republic", key: "LA", label: " لائوس" },
  { name: "Latvia", key: "LV", label: "لاتویا" },
  { name: "Lebanon", key: "LB", label: "لبنان" },
  { name: "Lesotho", key: "LS", label: "لسوتو" },
  { name: "Liberia", key: "LR", label: "لیبریا" },
  { name: "Libyan Arab Jamahiriya", key: "LY", label: "لیبی" },
  { name: "Liechtenstein", key: "LI", label: "لیختنشتاین" },
  { name: "Lithuania", key: "LT", label: "لیتوانی" },
  { name: "Luxembourg", key: "LU", label: "لوگزامبورگ" },
  { name: "Macao", key: "MO", label: "ماکائو" },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    key: "MK",
    label: "مقدونیه",
  },
  { name: "Madagascar", key: "MG", label: "ماداگاسکار" },
  { name: "Malawi", key: "MW", label: "مالاوی" },
  { name: "Malaysia", key: "MY", label: "مالزی" },
  { name: "Maldives", key: "MV", label: "مالدیو" },
  { name: "Mali", key: "ML", label: "مالی" },
  { name: "Malta", key: "MT", label: "مالت" },
  { name: "Marshall Islands", key: "MH", label: "جزایر مارشال" },
  { name: "Mauritania", key: "MR", label: "موریتانی" },
  { name: "Mauritius", key: "MU", label: "موریس" },
  { name: "Mexico", key: "MX", label: "مکزیک" },
  { name: "Micronesia, Federated States of", key: "FM", label: "میکرونزی" },
  { name: "Moldova, Republic of", key: "MD", label: "مولداوی" },
  { name: "Monaco", key: "MC", label: "موناکو" },
  { name: "Mongolia", key: "MN", label: "مغولستان" },
  { name: "Montenegro", key: "ME", label: "مونتنگرو" },
  { name: "Morocco", key: "MA", label: "مراکش" },
  { name: "Mozambique", key: "MZ", label: "موزامبیک" },
  { name: "Myanmar", key: "MM", label: "میانمار" },
  { name: "Namibia", key: "NA", label: "نامیبیا" },
  { name: "Nauru", key: "NR", label: "نائورو" },
  { name: "Nepal", key: "NP", label: "نپال" },
  { name: "Netherlands", key: "NL", label: "هلند" },
  { name: "Netherlands Antilles", key: "AN", label: "آنتیل هلند" },
  { name: "New Zealand", key: "NZ", label: "نیوزیلند" },
  { name: "Nicaragua", key: "NI", label: "نیکاراگوئه" },
  { name: "Niger", key: "NE", label: "نیجر" },
  { name: "Nigeria", key: "NG", label: "نیجریه" },
  { name: "Northern Mariana Islands", key: "MP", label: "جزایر ماریان شمالی" },
  { name: "Norway", key: "NO", label: "نروژ" },
  { name: "Oman", key: "OM", label: "عمان" },
  { name: "Pakistan", key: "PK", label: "پاکستان" },
  { name: "Palau", key: "PW", label: "پالائو" },
  { name: "Palestinian Territory, Occupied", key: "PS", label: "فلسطین" },
  { name: "Panama", key: "PA", label: "پاناما" },
  { name: "Papua New Guinea", key: "PG", label: "پاپوا گینه نو" },
  { name: "Paraguay", key: "PY", label: "پاراگوئه" },
  { name: "Peru", key: "PE", label: "پرو" },
  { name: "Philippines", key: "PH", label: "فیلیپین" },
  { name: "Poland", key: "PL", label: "لهستان" },
  { name: "Portugal", key: "PT", label: "پرتغال" },
  { name: "Puerto Rico", key: "PR", label: "پورتو ریکو" },
  { name: "Qatar", key: "QA", label: "قطر" },
  { name: "Romania", key: "RO", label: "رومانی" },
  { name: "Russian Federation", key: "RU", label: "روسیه" },
  { name: "RWANDA", key: "RW", label: "رواندا" },
  { name: "Saint Kitts and Nevis", key: "KN", label: "سنت کیتس و نویس" },
  { name: "Samoa", key: "WS", label: "ساموآ" },
  { name: "San Marino", key: "SM", label: "سن مارینو" },
  { name: "Saudi Arabia", key: "SA", label: "عربستان" },
  { name: "Senegal", key: "SN", label: "سنگال" },
  { name: "Serbia", key: "RS", label: "صربستان" },
  { name: "Seychelles", key: "SC", label: "سیشل" },
  { name: "Sierra Leone", key: "SL", label: "سیرالئون" },
  { name: "Singapore", key: "SG", label: "سنگاپور" },
  { name: "Slovakia", key: "SK", label: "اسلوواکی" },
  { name: "Slovenia", key: "SI", label: "اسلوونی" },
  { name: "Solomon Islands", key: "SB", label: "جزایر سلیمان" },
  { name: "Somalia", key: "SO", label: "سومالی" },
  { name: "South Africa", key: "ZA", label: "آفریقای جنوبی" },
  { name: "Spain", key: "ES", label: "اسپانیا" },
  { name: "Sri Lanka", key: "LK", label: "سریلانکا" },
  { name: "Sudan", key: "SD", label: "سودان" },
  { name: "Suriname", key: "SR", label: "سورینام" },
  { name: "Swaziland", key: "SZ", label: "سوازیلند" },
  { name: "Sweden", key: "SE", label: "سوئد" },
  { name: "Switzerland", key: "CH", label: "سوییس" },
  { name: "Syrian Arab Republic", key: "SY", label: "سوریه" },
  { name: "Taiwan, Province of China", key: "TW", label: "تایوان" },
  { name: "Tajikistan", key: "TJ", label: "تاجیکستان" },
  { name: "Tanzania, United Republic of", key: "TZ", label: "تانزانیا" },
  { name: "Thailand", key: "TH", label: "تایلند" },
  { name: "Timor-Leste", key: "TL", label: "تیمور شرقی" },
  { name: "Togo", key: "TG", label: "توگو" },
  { name: "Tonga", key: "TO", label: "تونگا" },
  { name: "Trinidad and Tobago", key: "TT", label: "ترینیداد" },
  { name: "Tunisia", key: "TN", label: "تونس" },
  { name: "Turkey", key: "TR", label: "ترکیه" },
  { name: "Turkmenistan", key: "TM", label: "ترکمنستان" },
  { name: "Tuvalu", key: "TV", label: "تووالو" },
  { name: "Uganda", key: "UG", label: "اوگاندا" },
  { name: "Ukraine", key: "UA", label: "اوکراین" },
  { name: "United Arab Emirates", key: "AE", label: "امارات متحده" },
  { name: "United Kingdom", key: "GB", label: "انگلیس" },
  { name: "United States", key: "US", label: "آمریکا" },
  { name: "Uruguay", key: "UY", label: "اروگوئه" },
  { name: "Uzbekistan", key: "UZ", label: "ازبسکتان" },
  { name: "Vanuatu", key: "VU", label: "وانواتو" },
  { name: "Venezuela", key: "VE", label: "ونزوئلا" },
  { name: "Viet Nam", key: "VN", label: "ویتنام" },
  { name: "Western Sahara", key: "EH", label: "صحرای غربی" },
  { name: "Yemen", key: "YE", label: "یمن" },
  { name: "Zambia", key: "ZM", label: "زامبیا" },
  { name: "Zimbabw", key: "Z", label: "زیمباوه" },
];

export const ageRangeFilters = [
  {
    label: "تا ۷ سال",
    key: 7,
  },
  {
    label: "تا ۱۳ سال",
    key: 13,
  },
  {
    label: "تا ۱۸ سال",
    key: 18,
  },
  {
    label: "بزرگسال",
    key: 120,
  },
];

export const yearFilters = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, index) => {
    const year = 1900 + index;
    const jalaliYear = toJalali(year);
    return {
      label: `${year} (${jalaliYear})`,
      key: year.toString(),
    };
  }
);

function toJalali(year) {
  const jalaliYear = moment(year, "YYYY").format("jYYYY");

  return jalaliYear;
}

export const sortingFilters = [
  {
    label: "جدیدترین",
    key: "newest",
  },
  {
    label: "پربازدیدترین",
    key: "most-viewed",
  },
  {
    label: "پرامتیازترین",
    key: "top-rated",
  },
  {
    label: "قدیمی ترین",
    key: "oldest",
  },
];
